// extracted by mini-css-extract-plugin
export default {"searchContent":"NewsPage_searchContent__MMUyE","searchInfo":"NewsPage_searchInfo__okkPP","results":"NewsPage_results__chOkQ"};